/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { useSimpliCity } from "@simplicitycms/simplicity-common";
import { LayoutWrapperCore } from "cms/layout/layout-wrapper-core";
import { ErrorLayoutFullWidth } from "layout/error/data-error/error-fullwidth";
import { LayoutSelector } from "layout/layout-selector";
import React from "react";

const LayoutWrapper = () => {

    let { webpage, model, error, loading } = useSimpliCity();

    return (
        <>
            <LayoutWrapperCore >

                {webpage && model &&
                    <LayoutSelector />
                }

                {error && !loading &&
                    <ErrorLayoutFullWidth />
                }

            </LayoutWrapperCore>

        </>
    );
};

LayoutWrapper.displayName = "LayoutWrapper";
export { LayoutWrapper };
